import React from "react";

import AndUsFooter from "./uniComponents/AndUsFooter";
import Navbar from "./clientHom/Navbar";
import HeroSection from "./clientHom/HeroSection";
import CustomSystemsSection from "./clientHom/CustomSystemsSection";
import PartnersSection from "./clientHom/PartnersSection";
import UnityLearningSection from "./clientHom/UnityLearningSection";
import TalentLenzSection from "./clientHom/TalentLenzSection";
import FleetCoreSection from "./clientHom/FleetCoreSection";
import TPCGroupSection from "./clientHom/TPCGroupSection";
import AppliedIntelligenceSection from "./clientHom/AppliedIntelligenceSection";

import "./clientHom/ClientHome.css";

/**
 * Public AndUs landing page.
 *
 * The previous Home page has moved to /office-only and now lives in
 * src/pages/OfficeOnly.js.
 *
 * Landing-page sections live in src/pages/clientHom.
 */
export default function Home() {
  return (
    <div id="top" className="andus-client-home">
      <Navbar />

      <main className="andus-client-home__main">
        <HeroSection />
        <CustomSystemsSection />
        <PartnersSection />
        <UnityLearningSection />
        <TalentLenzSection />
        <FleetCoreSection />
        <TPCGroupSection />
        <AppliedIntelligenceSection />
      </main>

      <AndUsFooter />
    </div>
  );
}